var giphy_viewer_default = {
  "giphyWrapper": "He8e8",
  "giphy_player": "F-Am9",
  "playIcon": "RuF1v",
  "gifRatio": "L9mFD"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
